
import { Component, Vue, Prop} from 'vue-property-decorator';


@Component({
    components:{
    }
})
export default class ErrorSubmitManualForm extends Vue {
    
    @Prop({required: true, default:" "})
    errMsg!: string;
 
    mountedData = false;     

    mounted() {
        this.mountedData = false;        
        this.deleteApplication()       
        this.mountedData = true;                   
    }
    
    public deleteApplication() {

        const caseId = this.$route.params?.id
        const data ={
            data:{
                ids:[caseId]
            }
        }

        const url = '/manual-submissions/forms';
        this.$http.delete(url, data)
        .then(response => {
        }, err => {            
        })
    }

    public done() {
        this.$router.push({name: "dashboard" }) 
    }

    public contactUs(){
        const ContactButton = document.getElementsByName("contact-us");
        if(ContactButton[0]) ContactButton[0].click()
    }
}
